import React, { Fragment } from "react";
import { Box, Divider } from "@material-ui/core";

interface StackProps {
  direction?: "row" | "column";
  alignItems?: string;
  justifyContent?: string;
  spacing?: number;
  children: React.ReactNode;
  divider?: boolean;
  style?: React.CSSProperties;
}

const Stack: React.FC<StackProps> = ({
  direction = "column",
  alignItems = "center",
  justifyContent = "space-between",
  spacing = 2,
  children,
  divider = false,
  style,
}) => {
  const spacingValue = spacing * 8;

  return (
    <Box
      display="flex"
      flexDirection={direction}
      justifyContent={justifyContent}
      alignItems={alignItems}
      style={{
        gap: `${spacingValue}px`,
        ...style,
      }}
      flexWrap="wrap"
    >
      {React.Children.map(children, (child, index) => (
        <Fragment key={index}>
          <Box>{child}</Box>

          {divider && index < React.Children.count(children) - 1 && (
            <Divider
              orientation={direction === "column" ? "horizontal" : "vertical"}
              flexItem
            />
          )}
        </Fragment>
      ))}
    </Box>
  );
};

export default Stack;
